/* eslint no-use-before-define: 0 */

import $ from "jquery";
import { fireSearchRequested } from "@sharedFrontend/globalEvents";
// eslint-disable-next-line import/no-cycle
import SecurityService from "@security/Services/SecurityService";

export default class RestService {
    /**
     * @param {Object} requestData - json data for backend
     * @param {number} requestData.lat - lat coordinate
     * @param {number} requestData.lng - lng coordinate
     * @param {string} requestData.query - search query
     * @param {Array<string>} requestData.premiseTemplateIds - selected premise template Ids
     * @returns {Object} - Promise via jQuery deferred
     */
    static sendSearchRequest(requestData) {
        fireSearchRequested();

        const deferred = $.Deferred();

        addCityNameIfHaveIt(requestData);
        addDbAndLangToRequest(requestData);
        removeNullPropertiesFromRequest(requestData);
        formatNonIntegerNumbersFromRequest(requestData);
        removeEmptyArraysFromRequest(requestData);

        if (RestService.currentSearchRequest) {
            RestService.currentSearchRequest.abort();
        }

        RestService.currentSearchRequest = $.ajax({
            type: "POST",
            url: "/api/SearchPanelApi/Search",
            data: requestData,
            success: (response) => {
                RestService.currentSearchRequest = null;
                deferred.resolve(response.result);
            },
            fail: (response) => {
                RestService.currentSearchRequest = null;
                deferred.reject(response);
            },
            dataType: "json",
            beforeSend: xhr => xhr.setRequestHeader("__RequestVerificationToken", SecurityService.CSRFToken),
        });

        return deferred.promise();

        function addCityNameIfHaveIt() {
            if (!requestData.address_components) return;

            let cityName = null;

            requestData.address_components.forEach((addressComponent) => {
                if (!addressComponent.types) return;
                if (addressComponent.types.includes("locality") && addressComponent.types.includes("locality")) {
                    cityName = addressComponent.long_name;
                }
            });

            // eslint-disable-next-line no-param-reassign
            delete requestData.address_components;

            // eslint-disable-next-line no-param-reassign
            requestData.cityName = cityName;
        }

        function formatNonIntegerNumbersFromRequest() {
            // eslint-disable-next-line no-restricted-syntax
            for (const property in requestData) {
                if (
                    // eslint-disable-next-line no-prototype-builtins
                    requestData.hasOwnProperty(property)
                    && typeof requestData[property] === "number"
                    && !isInteger(requestData[property])
                ) {
                    // eslint-disable-next-line no-param-reassign
                    requestData[property] = requestData[property].toFixed(6).toString().replace(".", ",");
                }
            }

            function isInteger(x) {
                return x === parseInt(x, 10);
            }
        }

        function removeNullPropertiesFromRequest() {
            Object
                .keys(requestData)
                .forEach(key => requestData[key] == null // eslint-disable-next-line no-param-reassign
                    && delete requestData[key]);
        }

        function removeEmptyArraysFromRequest() {
            Object
                .keys(requestData)
                .forEach(key => Array.isArray(requestData[key]) && requestData[key].length === 0
                    && delete requestData[key]); // eslint-disable-line no-param-reassign
        }

        function addDbAndLangToRequest() {
            const contextMetaElement = $("#current-sitecore-context");

            // eslint-disable-next-line no-param-reassign
            requestData.databaseName = contextMetaElement.data("db");
            // eslint-disable-next-line no-param-reassign
            requestData.languageName = contextMetaElement.data("language");
        }
    }
}

RestService.currentSearchRequest = null;
